document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    setUniformHeight('.product-card__image');
    setUniformHeight('.product-card__title');
  }, 200);
});

window.addEventListener('resize', function () {
  setTimeout(() => {
    setUniformHeight('.product-card__image');
    setUniformHeight('.product-card__title');
  }, 200);
});


function setUniformHeight(selector) {
  const elements = document.querySelectorAll(selector);

  if (elements.length === 0) return;

    // Reset elements (e.g. during resize)
    elements.forEach((element) => {
      element.style.height = '';
    });

  let maxHeight = 0;
  elements.forEach((element) => {
    const elementHeight = element.offsetHeight;
    if (elementHeight > maxHeight) {
      maxHeight = elementHeight;
    }
  });

  elements.forEach((element) => {
    element.style.height = `${maxHeight}px`;
  });
}